<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <div class="management-area">
                <p class="title">{{ 'POWER_USERS' | translate }}</p>
                <p class="description">
                    {{ 'DESCRIPTION_NEW_USERS' | translate }}
                </p>

                <div class="management-area__power-user-title">
                    <span>{{ 'POWER_USERS_SUBTITLE' | translate }}</span>
                </div>

                <div class="management-area__power-user">
                    <a class="link link--action" routerLink="add">
                        <span>+ </span>
                        <span>{{ 'ADD_NEW_USER' | translate }}</span>
                    </a>
                </div>

                <div class="management-area__user">
                    <div class="table">
                        <ridango-table-row *ngFor="let user of powerUsers$ | async; let even = even" [isEven]="even">
                            <div class="col-item w5">
                                <span class="email-mobile">{{ 'EMAIL_ADDRESS' | translate }}</span>
                                {{ user.customerEmail }}
                            </div>
                            <div class="col-item w5"></div>

                            <div class="col-item w1 remove" *ngIf="user.accessType === AccessType.Admin">
                                <button
                                    class="link--no-line link--remove"
                                    [ngClass]="{ 'pn-dark:!text-white': even, 'pn-dark:!text-black': !even }"
                                    (click)="askToDelete(user)">
                                    {{ 'REMOVE_USER' | translate }}
                                </button>
                            </div>
                        </ridango-table-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ridango-dialog [size]="'460'" [visible]="showDeleteConfirmation" (onCloseModal)="cancelDelete()">
    <div class="dialog-460__title">
        {{ 'DIALOG_CONFIRM_DELETE_POWER_USER_TITLE' | translate }}
    </div>
    <div class="shopping-cart-time-area">
        <div class="shopping-cart-time-middle">
            <p>
                {{ 'DIALOG_CONFIRM_DELETE_POWER_USER_DESCRIPTION' | translate }}
            </p>
        </div>

        <div class="shopping-cart-time-bottom">
            <div class="dialog-bottom">
                <div class="dialog-bottom__right">
                    <button class="btn btn--primary btn--maximal" (click)="confirmDelete()">
                        {{ 'DIALOG_BUTTON_OK' | translate }}
                    </button>
                </div>
                <div class="dialog-bottom__left">
                    <a class="link link--action link--emphasized" (click)="cancelDelete()">
                        {{ 'DIALOG_BUTTON_CANCEL' | translate }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</ridango-dialog>
